import {
  EuiButtonEmpty,
  EuiFlexGroup,
  EuiFlexItem,
  EuiPageTemplate,
} from "@inscopix/ideas-eui";
import UserPreference from "components/UserPreference/UserPreference";
import { ModalEula } from "components/Eula/ModalEula";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  useSetCurrentPage,
  useTourStep,
} from "providers/TourProvider/TourProvider.hooks";
import { PanelMarketingPreference } from "./PanelMarketingPreference";
import { MFAManagement } from "./MFAManagement";

/**
 * Settings page
 */

export const PageSettings = () => {
  useSetCurrentPage("profile");
  const [isModalEulaVisible, setIsModalEulaVisible] = useState(false);
  const closeModalEula = () => setIsModalEulaVisible(false);
  const openModalEula = () => setIsModalEulaVisible(true);

  const { component: TourAccessPersonalSettings3, anchorId: anchorId3 } =
    useTourStep("TourAccessPersonalSettings", 3);

  return (
    <EuiPageTemplate restrictWidth={true}>
      <Helmet>
        <title>{`Profile`}</title>
      </Helmet>
      {isModalEulaVisible && <ModalEula onClose={closeModalEula} />}
      <EuiPageTemplate.Header
        pageTitle={"User Profile"}
        rightSideItems={[
          <EuiButtonEmpty
            key={"view-eula-button"}
            onClick={openModalEula}
            data-test-subj="view-eula-button"
            iconType="documentation"
            id={anchorId3}
          >
            View EULA
          </EuiButtonEmpty>,
        ]}
      />
      <EuiPageTemplate.Section>
        <EuiFlexGroup direction="column">
          <EuiFlexItem>
            <UserPreference />
          </EuiFlexItem>
          <EuiFlexItem>
            <MFAManagement />
          </EuiFlexItem>
          <PanelMarketingPreference />
        </EuiFlexGroup>
      </EuiPageTemplate.Section>
      {TourAccessPersonalSettings3}
    </EuiPageTemplate>
  );
};
